{
  "manager": {
    "productCategoryCreate": {
      "pageTitle": "Create Category",
      "submitLabel": "Create Category"
    },
    "productCategoryEdit": {
      "pageTitle": "Edit Category",
      "submitLabel": "Save Category"
    },
    "productTagCreate": {
      "pageTitle": "Create Tag",
      "submitLabel": "Create Tag"
    },
    "productTagEdit": {
      "pageTitle": "Edit Tag",
      "submitLabel": "Save Tag"
    },
    "productCreate": {
      "pageTitle": "Create Product",
      "saveAndCreateAnother": "Save & Create Another"
    },
    "productForm": {
      "nameLabel": "Name *",
      "namePlaceholder": "Enter a name for the product",
      "priceLabel": "Cost Per Quantity *",
      "applyTaxLabel": "Apply tax rates to this product"
    },
    "bookableEntityProducts": {
      "noLimit": "No limit"
    },
    "formCreateEditProduct": {
      "productDetails": "Product Details",
      "productName": "Product Name",
      "fieldRequired": "This field is required.",
      "productNamePlaceholder": "Enter product name...",
      "productPrice": "Product Price",
      "productPriceInvalid": "Product price must be 0 (free) or between 0.5 and 999,999.99",
      "productDescription": "Product Description",
      "productDescriptionPlaceholder": "Enter product description...",
      "applyTax": "Apply Tax",
      "applyTaxHelp": "Include applicable taxes for this product"
    },
    "formCreateEditProductCategory": {
      "detailsTitle": "Category Details",
      "nameLabel": "Category Name",
      "fieldRequired": "This field is required.",
      "namePlaceholder": "Enter category name...",
      "descriptionLabel": "Category Description",
      "descriptionPlaceholder": "Enter category description...",
      "associatedProductsTitle": "Associated Products"
    },
    "formCreateEditProductTag": {
      "detailsTitle": "Tag Details",
      "nameLabel": "Tag Name",
      "fieldRequired": "This field is required.",
      "namePlaceholder": "Enter tag name...",
      "associatedProductsTitle": "Associated Products"
    },
    "productSearchOrCreate": {
      "searchPlaceholder": "Search for a product",
      "typeToSearch": "Type to search through all {count} items"
    },
    "storeProgramForm": {
      "scheduleType": "Schedule Type"
    },
    "productCategoryIndex": {
      "title": "Product Categories"
    },
    "productCategoryShow": {
      "categoryOverview": "Category Overview",
      "nameLabel": "Name",
      "descriptionLabel": "Description",
      "noDescription": "No description provided",
      "createdLabel": "Created",
      "lastUpdatedLabel": "Last Updated",
      "assignedProducts": "Assigned Products",
      "noProductsAssigned": "No products assigned to this category.",
      "nameColumn": "Name",
      "priceColumn": "Price",
      "statusColumn": "Status",
      "statusActive": "Active",
      "statusArchived": "Archived",
      "loadFailed": "Failed to load category.",
      "backToCategories": "Back to Categories"
    },
    "productTagIndex": {
      "title": "Product Tags"
    },
    "productTagShow": {
      "overviewTitle": "Tag Overview",
      "nameLabel": "Name",
      "createdLabel": "Created",
      "lastUpdatedLabel": "Last Updated",
      "assignedProductsTitle": "Assigned Products",
      "noProductsAssigned": "No products assigned to this tag.",
      "priceLabel": "Price",
      "statusLabel": "Status",
      "statusActive": "Active",
      "statusArchived": "Archived",
      "loadFailed": "Failed to load tag.",
      "backToTags": "Back to Tags"
    },
    "productIndex": {
      "title": "Products",
      "assignCategories": "Assign Categories",
      "assignTags": "Assign Tags",
      "statusActive": "Active",
      "statusArchived": "Archived",
      "selectCategoriesLabel": "Select Categories *",
      "searchCategoriesPlaceholder": "Search for categories",
      "categoryRequired": "At least one category selection is required.",
      "selectTagsLabel": "Select Tags *",
      "searchTagsPlaceholder": "Search for tags",
      "tagRequired": "At least one tag selection is required."
    },
    "productShow": {
      "archivedAlert": "This product is archived.",
      "overviewTitle": "Product Overview",
      "nameLabel": "Name",
      "descriptionLabel": "Description",
      "noDescription": "No description provided",
      "priceLabel": "Price",
      "taxAppliedLabel": "Tax Applied",
      "statusLabel": "Status",
      "statusActive": "Active",
      "statusArchived": "Archived",
      "categoriesLabel": "Categories",
      "noCategories": "No categories",
      "tagsLabel": "Tags",
      "noTags": "No tags",
      "createdLabel": "Created",
      "lastUpdatedLabel": "Last Updated",
      "invoicePaid": "Paid",
      "invoiceUnpaid": "Unpaid",
      "bookingStateActive": "Active"
    },
    "modalCreateProduct": {
      "title": "Create Product",
      "createProduct": "Create Product"
    },
    "modalEditProduct": {
      "title": "Edit Product",
      "updateProduct": "Update Product"
    },
    "productEdit": {
      "title": "Edit Product",
      "saveProduct": "Save Product"
    }
  }
}
